/*
  StylinArts — TRUE AI PDP Recommendations v1
  AI-selected products rendered directly from /ai/private-edit + /products/{handle}.js
*/
(function () {
  "use strict";
  var VID_KEY = "sa_private_edit_vid";
  var AI_ENDPOINT = "/ai/private-edit";
  var PRODUCT_LIMIT = 6;

  function normaliseHandle(value) {
    value = String(value || "").trim();
    if (!value) return "";
    var m = value.match(/\/products\/([^/?#]+)/);
    return (m ? m[1] : value).replace(/\.js$/,"").toLowerCase();
  }

  function getVisitorId() {
    var id = localStorage.getItem(VID_KEY);
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : "sa_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2);
      localStorage.setItem(VID_KEY, id);
    }
    return id;
  }

  function getCurrentHandle(section) {
    var fromSection = section.getAttribute("data-current-product");
    if (fromSection) return normaliseHandle(fromSection);
    var profile = document.querySelector("[data-sa-product-profile]");
    if (profile && profile.dataset.handle) return normaliseHandle(profile.dataset.handle);
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && canonical.href) {
      var m = canonical.href.match(/\/products\/([^/?#]+)/);
      if (m) return normaliseHandle(m[1]);
    }
    var p = location.pathname.match(/\/products\/([^/?#]+)/);
    return p ? normaliseHandle(p[1]) : "";
  }

  function money(cents) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "AUD"
      }).format(value);
    } catch (e) {
      return "$" + value.toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, function (m) {
      return ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#039;" })[m];
    });
  }

  function colorToCss(name) {
    var n = String(name || "").toLowerCase().trim().replace(/\s+/g,"");
    var map = {black:"#111111",white:"#ffffff",ivory:"#f8f3e8",cream:"#f3ead8",red:"#9f0f1b",burgundy:"#5b0e17",wine:"#5b0e17",pink:"#e8a8b8",blush:"#f1c6cf",hotpink:"#d83b82",blue:"#234c9f",navy:"#101b3a",sky:"#9dc9e8",purple:"#6d3d8f",lavender:"#b8a2d9",lilac:"#c6b4e3",grey:"#b5b5b5",gray:"#b5b5b5",silver:"#c8c8c8",green:"#2f5a45",brown:"#6b4632",nude:"#c9a88d",gold:"#c8a54a"};
    return map[n] || n || "#ddd";
  }

  function getColorOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === "string" ? opts[i] : opts[i].name;
      if (/colou?r/i.test(name || "")) return i + 1;
    }
    return 1;
  }

  function imageFromVariantOrProduct(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (product.featured_image) return product.featured_image;
    if (Array.isArray(product.images) && product.images.length) return product.images[0];
    return "";
  }

  function firstAvailableVariant(product) {
    return (product.variants || []).find(function(v){ return v.available; }) || (product.variants || [])[0] || null;
  }

  async function fetchProduct(handle) {
    var h = normaliseHandle(handle);
    if (!h) return null;
    try {
      var res = await fetch("/products/" + encodeURIComponent(h) + ".js", { credentials: "same-origin", headers: { "Accept": "application/json" } });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function aiHandles(data, currentHandle) {
    var handles = [];
    function push(v) {
      var h = normaliseHandle(v && (v.handle || v.product_handle || v.url || v));
      if (h && h !== currentHandle && handles.indexOf(h) < 0) handles.push(h);
    }
    if (data.hero_product) push(data.hero_product);
    (data.products || []).forEach(push);
    (data.complete_the_mood || []).forEach(push);
    (data.supporting_products || []).forEach(push);
    (data.cinematic_pairing || []).forEach(push);
    return handles.slice(0, PRODUCT_LIMIT);
  }

  function confidenceGood(data) {
    var c = Number(data && data.confidence || 0);
    return c >= 30 || !!(data && (data.phase10_narrative || data.identity_graph || data.next_desire || data.timeline_story || data.cinematic_pairing));
  }

  function getSubline(data) {
    var phase10 = data.phase10_narrative || data.editorial_narrative || {};
    var identity = data.identity_graph || phase10.identity || {};
    var story = data.editorial_story || data.phase8_editorial || {};
    return phase10.evolution_summary || story.cinematic_caption || identity.silhouette_confidence || data.color_drift || data.mood_drift || "Selected from the details your browsing keeps circling back to.";
  }

  function renderCard(product, index) {
    var variant = firstAvailableVariant(product);
    var image = imageFromVariantOrProduct(product, variant);
    var role = index === 0 ? "YOUR NEXT BEST PIECE" : "DETAIL YOU RETURN TO";
    var price = variant ? variant.price : product.price;
    var url = product.url || ("/products/" + product.handle);
    var colorIndex = getColorOptionIndex(product);
    var seen = {};
    var swatches = [];

    (product.variants || []).forEach(function(v) {
      var color = v["option" + colorIndex] || v.option1 || "";
      var key = String(color || "").toLowerCase();
      if (!color || seen[key]) return;
      seen[key] = true;
      swatches.push({ color: color, image: imageFromVariantOrProduct(product, v), variantId: v.id });
    });

    var swatchHtml = swatches.slice(0, 5).map(function(s, i) {
      return '<button type="button" class="sa-ai-card__swatch' + (i === 0 ? ' is-active' : '') + '" aria-label="Show ' + escapeHtml(s.color) + '" title="' + escapeHtml(s.color) + '" data-color-name="' + escapeHtml(String(s.color).toLowerCase()) + '" data-image="' + escapeHtml(s.image || image) + '" style="--swatch:' + escapeHtml(colorToCss(s.color)) + '"></button>';
    }).join("");

    return '<article class="sa-ai-card' + (index === 0 ? ' is-hero' : '') + '" data-handle="' + escapeHtml(product.handle) + '">' +
      '<a class="sa-ai-card__media" href="' + escapeHtml(url) + '" aria-label="' + escapeHtml(product.title) + '">' +
        '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="' + (index === 0 ? 'eager' : 'lazy') + '" decoding="async">' +
        '<button type="button" class="sa-ai-card__heart sa-wishlist-heart" data-sa-wishlist-heart data-product-handle="' + escapeHtml(product.handle) + '" aria-label="Save to wishlist">♡</button>' +
      '</a>' +
      '<span class="sa-ai-card__role">' + role + '</span>' +
      '<a class="sa-ai-card__title" href="' + escapeHtml(url) + '">' + escapeHtml(product.title) + '</a>' +
      '<div class="sa-ai-card__price">' + money(price) + '</div>' +
      '<div class="sa-ai-card__swatches" aria-label="Available colours">' + swatchHtml + '</div>' +
    '</article>';
  }

  function bindSwatches(rail) {
    rail.addEventListener("click", function(e) {
      var sw = e.target.closest(".sa-ai-card__swatch");
      if (!sw) return;
      e.preventDefault();
      e.stopPropagation();
      var card = sw.closest(".sa-ai-card");
      var img = card && card.querySelector(".sa-ai-card__media img");
      var src = sw.getAttribute("data-image");
      if (img && src) img.src = src;
      card.querySelectorAll(".sa-ai-card__swatch").forEach(function(btn) {
        btn.classList.toggle("is-active", btn === sw);
      });
    });
  }

  function fallback(section) {
    section.removeAttribute("data-sa-ai-active");
    section.setAttribute("data-sa-ai-status", "fallback-shopify");
    var rail = section.querySelector("[data-sa-ai-real-rail]");
    var fb = section.querySelector("[data-sa-ai-fallback]");
    if (rail) { rail.hidden = true; rail.innerHTML = ""; }
    if (fb) fb.hidden = false;
  }

  async function runSection(section) {
    if (!section || section.dataset.saAiRunnerBusy === "1") return;
    section.dataset.saAiRunnerBusy = "1";

    var rail = section.querySelector("[data-sa-ai-real-rail]");
    var fb = section.querySelector("[data-sa-ai-fallback]");
    var heading = section.querySelector("[data-sa-ai-heading]");
    var kicker = section.querySelector("[data-sa-ai-kicker]");
    var note = section.querySelector("[data-sa-ai-note]");
    var hint = section.querySelector("[data-sa-ai-hint]");
    var continuation = section.querySelector("[data-sa-ai-continuation]");

    try {
      var visitorId = getVisitorId();
      var currentHandle = getCurrentHandle(section);
      var url = AI_ENDPOINT + "?visitor_id=" + encodeURIComponent(visitorId) + "&product_handle=" + encodeURIComponent(currentHandle || "") + "&surface=pdp_related_true_ai&debug=1";
      var res = await fetch(url, { credentials: "same-origin", headers: { "Accept": "application/json" } });
      if (!res.ok) return fallback(section);
      var data = await res.json();
      if (!data || !data.ok || !confidenceGood(data)) return fallback(section);

      var handles = aiHandles(data, currentHandle);
      if (!handles.length) return fallback(section);

      var products = (await Promise.all(handles.map(fetchProduct))).filter(Boolean);
      if (!products.length) return fallback(section);

      rail.innerHTML = products.map(renderCard).join("");
      bindSwatches(rail);

      section.setAttribute("data-sa-ai-active", "true");
      section.setAttribute("data-sa-ai-status", "true-ai-products");
      section.setAttribute("data-sa-ai-products", products.map(function(p){ return p.handle; }).join(","));
      section.setAttribute("data-sa-ai-confidence", String(data.confidence || ""));

      if (fb) fb.hidden = true;
      if (rail) rail.hidden = false;
      if (kicker) kicker.textContent = "CURATED BY STYLINARTS AI";
      if (heading) heading.textContent = "YOUR NEXT BEST PIECE";
      if (note) { note.textContent = getSubline(data); note.hidden = false; }
      if (hint) hint.textContent = "AI-selected from your private edit";
      if (continuation) continuation.hidden = false;
      if (window.saWishlistBoot) { try { window.saWishlistBoot(); } catch(e) {} }
    } catch (e) {
      fallback(section);
    } finally {
      section.dataset.saAiRunnerBusy = "0";
      section.dataset.saAiRunnerReady = "1";
    }
  }

  function runAll() { document.querySelectorAll("[data-sa-pdp-ai-recs]").forEach(runSection); }

  function observe() {
    var timer = null;
    var observer = new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(runAll, 150);
    });
    observer.observe(document.documentElement, { childList:true, subtree:true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { runAll(); observe(); });
  } else {
    runAll();
    observe();
  }

  document.addEventListener("shopify:section:load", runAll);
  window.saPdpAiRecommendationsRun = runAll;
})();
